export type TranslationTitles = Record<string, string>

export interface TranslationLanguageData {
  categoryTitles?: TranslationTitles
  productTitles?: TranslationTitles
}

export interface TranslationsState {
  items: Record<string, TranslationLanguageData>
  isTranslationsLoaded: boolean
  isTranslationsLoading: boolean
}

export const initialState: TranslationsState = {
  items: {},
  isTranslationsLoaded: false,
  isTranslationsLoading: false,
}
